(function() {
  'use strict';

  const CONFIG = {
    maxLength: 12,
    allowedPattern: /^[a-zA-Z0-9\s!@#$%^&*()_\-.,'"]*$/,
    engravingPrice: 0,
    textOverlayPosition: { bottom: '15%' }
  };

  let currentVariantId = null;
  let selectedPersonalizationText = '';
  let isPersonalizationEnabled = false;

  const elements = {
    overlay: null,
    modal: null,
    openBtn: null,
    closeBtn: null,
    skipBtn: null,
    confirmBtn: null,
    previewBtn: null,
    input: null,
    textOverlay: null,
    productImage: null,
    errorMessage: null,
    tncToggle: null,
    tncContent: null,
    hiddenTextInput: null,
    previewOverlay: null,
    previewImage: null,
    previewText: null,
    closePreview: null
  };

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupElements);
    } else {
      setupElements();
    }
  }

  function setupElements() {
    elements.overlay = document.getElementById('personalizationModalOverlay');
    elements.modal = document.getElementById('personalizationModal');
    elements.openBtn = document.getElementById('openPersonalizationModal');
    elements.closeBtn = document.getElementById('closePersonalizationModal');
    elements.skipBtn = document.getElementById('skipPersonalization');
    elements.confirmBtn = document.getElementById('confirmPersonalization');
    elements.previewBtn = document.getElementById('previewPersonalization');
    elements.input = document.getElementById('personalizationInput');
    elements.textOverlay = document.getElementById('personalizationTextOverlay');
    elements.productImage = document.getElementById('personalizationProductImage');
    elements.errorMessage = document.getElementById('personalizationError');
    elements.hiddenTextInput = document.getElementById('personalizationText');
    elements.previewOverlay = document.getElementById('personalizationPreviewOverlay');
    elements.previewImage = document.getElementById('previewImage');
    elements.previewText = document.getElementById('previewText');
    elements.closePreview = document.getElementById('closePreview');

    if (!elements.overlay || !elements.openBtn) {
      console.warn('Personalization modal elements not found');
      return;
    }

    attachEventListeners();
    detectCurrentVariant();
  }

  function attachEventListeners() {
    if (elements.openBtn) {
      elements.openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    }

    // Close modal
    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    if (elements.overlay) {
      elements.overlay.addEventListener('click', function(e) {
        if (e.target === elements.overlay) {
          closeModal();
        }
      });
    }

    if (elements.skipBtn) {
      elements.skipBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        skipPersonalization();
      });
    }

    if (elements.confirmBtn) {
      elements.confirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        confirmPersonalization();
      });
    }

    if (elements.previewBtn) {
      elements.previewBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openPreview();
      });
    }

    if (elements.closePreview) {
      elements.closePreview.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closePreview();
      });
    }

    if (elements.previewOverlay) {
      elements.previewOverlay.addEventListener('click', function(e) {
        if (e.target === elements.previewOverlay) {
          closePreview();
        }
      });
    }

    if (elements.input) {
      elements.input.addEventListener('input', handleInput);
      elements.input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!elements.confirmBtn.disabled) {
            confirmPersonalization();
          }
        }
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target.name === 'id' || e.target.classList.contains('variant-selector')) {
        detectCurrentVariant();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.overlay && elements.overlay.style.display !== 'none') {
        closeModal();
      }
    });
  }

  function openModal() {
    if (!elements.overlay) return;

    detectCurrentVariant();
    updateModalContent();
    
    elements.overlay.style.display = 'flex';
    
    setTimeout(() => {
      elements.overlay.classList.add('active');
    }, 10);

    if (elements.input) {
      setTimeout(() => {
        elements.input.focus();
      }, 300);
    }

    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!elements.overlay) return;

    elements.overlay.classList.remove('active');
    
    setTimeout(() => {
      elements.overlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  function skipPersonalization() {
    isPersonalizationEnabled = false;
    selectedPersonalizationText = '';
    
    if (elements.hiddenTextInput) elements.hiddenTextInput.value = '';
    closeModal();
  }

  function confirmPersonalization() {
    const text = elements.input ? elements.input.value.trim() : '';
    
    if (!text || !validateInput(text)) {
      showError('Please enter a valid personalization text');
      return;
    }

    isPersonalizationEnabled = true;
    selectedPersonalizationText = text;
    
    if (elements.hiddenTextInput) elements.hiddenTextInput.value = text;
    
    closeModal();
    
    addToCart(currentVariantId, true, text);
  }

  function handleInput(e) {
    const text = e.target.value;
    
    updateTextPreview(text);
    
    const isValid = validateInput(text);
    
    if (elements.confirmBtn) {
      elements.confirmBtn.disabled = !isValid || text.trim() === '';
    }
    if (elements.previewBtn) {
      elements.previewBtn.disabled = !isValid || text.trim() === '';
    }

    if (isValid) {
      hideError();
    }
  }

  function validateInput(text) {
    if (text.length > CONFIG.maxLength) {
      showError(`Maximum ${CONFIG.maxLength} characters allowed`);
      return false;
    }

    if (!CONFIG.allowedPattern.test(text)) {
      showError('Invalid characters detected. Only letters, numbers, and select special characters allowed.');
      return false;
    }

    const emojiPattern = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
    if (emojiPattern.test(text)) {
      showError('Emojis are not allowed');
      return false;
    }

    return true;
  }

  function showError(message) {
    if (elements.errorMessage) {
      elements.errorMessage.textContent = message;
      elements.errorMessage.style.display = 'block';
    }
  }

  function hideError() {
    if (elements.errorMessage) {
      elements.errorMessage.style.display = 'none';
      elements.errorMessage.textContent = '';
    }
  }

  function updateTextPreview(text) {
    if (!elements.textOverlay) return;

    if (text.trim() === '') {
      elements.textOverlay.textContent = '';
      elements.textOverlay.style.display = 'none';
    } else {
      elements.textOverlay.textContent = text;
      elements.textOverlay.style.display = 'block';
      
      if (currentVariantId && window.personalizationData && window.personalizationData[currentVariantId]) {
        const variantData = window.personalizationData[currentVariantId];
        if (variantData.textStyle) {
          Object.assign(elements.textOverlay.style, variantData.textStyle);
        }
      }
    }
  }

  function detectCurrentVariant() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      currentVariantId = variantInput.value;
      return;
    }

    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      currentVariantId = variantSelect.value;
      return;
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantIdInput = productForm.querySelector('[name="id"]');
      if (variantIdInput) {
        currentVariantId = variantIdInput.value;
        return;
      }
    }

    const themeVariantSelectors = [
      '.product-form__input input[name="id"]',
      '#product-select',
      '.variant-select',
      '[data-variant-id]'
    ];

    for (const selector of themeVariantSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        currentVariantId = element.value || element.dataset.variantId;
        if (currentVariantId) return;
      }
    }

    console.warn('Could not detect current variant');
  }

  function updateModalContent() {
    if (!currentVariantId || !window.personalizationData) return;

    const variantData = window.personalizationData[currentVariantId];
    if (!variantData) return;

    if (elements.productImage) {
      if (variantData.image) {
        elements.productImage.src = variantData.image;
      } else {
        const featuredImage = document.querySelector('.product-featured-image img, .product__media img, [data-product-featured-image]');
        if (featuredImage) {
          elements.productImage.src = featuredImage.src;
        }
      }
    }

    if (elements.textOverlay && variantData.textStyle) {
      Object.assign(elements.textOverlay.style, variantData.textStyle);
    }
    
    if (elements.input && elements.input.value) {
      updateTextPreview(elements.input.value);
    }
  }


  function openPreview() {
    const text = elements.input ? elements.input.value.trim() : '';
    
    if (!text || !validateInput(text)) {
      showError('Please enter valid text to preview');
      return;
    }

    if (!elements.previewOverlay) return;

    if (elements.previewImage && elements.productImage) {
      elements.previewImage.src = elements.productImage.src;
    }

    if (elements.previewText) {
      elements.previewText.textContent = text;
      
      if (currentVariantId && window.personalizationData && window.personalizationData[currentVariantId]) {
        const variantData = window.personalizationData[currentVariantId];
        if (variantData.textStyle) {
          Object.assign(elements.previewText.style, variantData.textStyle);
          elements.previewText.style.fontSize = '18px';
        }
      }
    }

    elements.previewOverlay.style.display = 'flex';
    setTimeout(() => {
      elements.previewOverlay.classList.add('active');
    }, 10);
  }

  function closePreview() {
    if (!elements.previewOverlay) return;

    elements.previewOverlay.classList.remove('active');
    setTimeout(() => {
      elements.previewOverlay.style.display = 'none';
    }, 300);
  }

  function addToCart(variantId, withPersonalization, text = '') {
    if (!variantId) {
      alert('Please select a variant');
      return;
    }

    const formData = {
      id: variantId,
      quantity: 1
    };

    if (withPersonalization && text) {
      formData.properties = {
        'Personalization': text
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);
      
      if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cartDrawer) {
        Shopify.theme.cartDrawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      
      setTimeout(() => {
        updateCartCount();
      }, 500);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('❌ Error adding to cart. Please try again.');
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  window.toggleTnC = function() {
    const tncContent = document.getElementById('tncContent');
    const tncToggle = document.querySelector('.tnc-toggle');
    
    if (tncContent && tncToggle) {
      tncContent.classList.toggle('active');
      tncToggle.classList.toggle('active');
      
      if (tncContent.classList.contains('active')) {
        tncContent.style.display = 'block';
      } else {
        setTimeout(() => {
          tncContent.style.display = 'none';
        }, 300);
      }
    }
  };

  window.PersonalizationModal = {
    open: openModal,
    close: closeModal,
    openPreview: openPreview,
    closePreview: closePreview,
    getCurrentVariant: () => currentVariantId,
    getPersonalizationText: () => selectedPersonalizationText,
    isEnabled: () => isPersonalizationEnabled
  };

  init();

})();
